import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    #e5e7eb 25%,
    #d1d5db 37%,
    #e5e7eb 63%
  );
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  border-radius: 6px;
`;

export const Container = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 20px;
`;

export const ContentWrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

export const SkeletonTitle = styled(SkeletonBase)`
  height: 32px;
  width: 60%;
  margin: 0 auto 12px;
`;

export const SkeletonSubtitle = styled(SkeletonBase)`
  height: 18px;
  width: 50%;
  margin: 0 auto 32px;
`;

export const SkeletonTimerRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
`;

export const SkeletonTextSmall = styled(SkeletonBase)`
  height: 16px;
  width: 180px;
`;

export const SkeletonTimer = styled(SkeletonBase)`
  height: 36px;
  width: 90px;
  border-radius: 8px;
`;

export const PixCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  border: 1px solid #e5e7eb;
`;

export const StatusRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
`;

export const SkeletonCircle = styled(SkeletonBase)`
  width: 20px;
  height: 20px;
  border-radius: 50%;
`;

export const SkeletonStatusText = styled(SkeletonBase)`
  height: 20px;
  width: 220px;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

export const QRCodeBox = styled(SkeletonBase)`
  width: 220px;
  height: 220px;
  border-radius: 12px;
`;

export const ApprovalRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 24px 0;
`;

export const SkeletonCircleSmall = styled(SkeletonBase)`
  width: 18px;
  height: 18px;
  border-radius: 50%;
`;

export const SkeletonApprovalText = styled(SkeletonBase)`
  height: 14px;
  width: 260px;
`;

export const ButtonSkeleton = styled(SkeletonBase)`
  height: 48px;
  width: 220px;
  margin: 24px auto;
  border-radius: 8px;
`;

export const Instructions = styled.div`
  margin-top: 32px;
`;

export const SkeletonSectionTitle = styled(SkeletonBase)`
  height: 18px;
  width: 200px;
  margin-bottom: 16px;
`;

export const InstructionLine = styled(SkeletonBase)`
  height: 14px;
  width: 100%;
  margin-bottom: 10px;
`;

export const CodeBox = styled.div`
  margin-top: 24px;
  padding: 16px;
  border-radius: 8px;
  border: 2px dashed #d1d5db;
`;

export const CodeLabel = styled(SkeletonBase)`
  height: 12px;
  width: 160px;
  margin-bottom: 10px;
`;

export const CodeLine = styled(SkeletonBase)`
  height: 12px;
  width: 100%;
  margin-bottom: 6px;
`;